import { ActiveGateway, GatewayFeeModel, GatewayFeePayer } from "../../types/financial";

export function getGatewayDisplayName(gateway: ActiveGateway | string): string {
  const norm = String(gateway || "").toUpperCase();
  if (norm.includes("ASAAS")) return "Asaas Gateway (Pix Instantâneo)";
  if (norm.includes("MERCADO") || norm.includes("MP")) return "Mercado Pago";
  return "Gateway Transacional";
}

export function formatFeeDescription(
  model: GatewayFeeModel,
  fixed: number,
  percentage: number,
  payer: GatewayFeePayer
): string {
  let feeText = "";
  if (model === "FIXED") {
    feeText = `R$ ${fixed.toFixed(2).replace(".", ",")}`;
  } else if (model === "PERCENTAGE") {
    feeText = `${percentage.toString().replace(".", ",")}%`;
  } else {
    feeText = `R$ ${fixed.toFixed(2).replace(".", ",")} + ${percentage.toString().replace(".", ",")}%`;
  }

  const payerText = payer === "ARENA" ? "descontada da Arena" : "paga pela Plataforma";
  return `${feeText} (${payerText})`;
}

export function calculateGatewayFeeAmount(
  amount: number,
  model: GatewayFeeModel,
  fixed: number,
  percentage: number
): number {
  const safeGross = Math.max(0, Number(amount) || 0);
  let fee = 0;
  if (model === "FIXED") {
    fee = fixed;
  } else if (model === "PERCENTAGE") {
    fee = (safeGross * percentage) / 100;
  } else if (model === "BOTH") {
    fee = fixed + (safeGross * percentage) / 100;
  }
  return Number(fee.toFixed(2));
}
